export default "__VITE_ASSET__DrIXIsyS__"